/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    sdpLabel: {
        id: 'qnb.spm.vehicleUse.sdpLabel',
        defaultMessage: 'Social, Domestic & Pleasure (SDP)'
    },
    sdpInfo: {
        id: 'qnb.spm.vehicleUse.sdpInfo',
        defaultMessage: ' covers day-to-day use by yourself or any named drivers. This does not include any commuting to or from any place of employment, or any business use.'
    },
    commutingLabel: {
        id: 'qnb.spm.vehicleUse.commutingLabel',
        defaultMessage: 'SDP + Commuting'
    },
    commutingInfo: {
        id: 'qnb.spm.vehicleUse.commutingInfo',
        defaultMessage: ' covers you and, if named on the policy, your spouse or domestic partner for social use and commuting to and from one place of employment each.'
    },
    personalBusinessLabel: {
        id: 'qnb.spm.vehicleUse.personalBusinessLabel',
        defaultMessage: 'SDP + Personal Business Use'
    },
    personalBusinessInfo: {
        id: 'qnb.spm.vehicleUse.personalBusinessInfo',
        defaultMessage: ' covers you, and if named, your spouse or domestic partner, for social use, commuting to one or more places of employment; and in connection with each of your businesses or professions (but not for soliciting orders).'
    },
    businessLabel: {
        id: 'qnb.spm.vehicleUse.businessLabel',
        defaultMessage: 'SDP + Business Use'
    },
    businessInfo: {
        id: 'qnb.spm.vehicleUse.businessInfo',
        defaultMessage: ' covers you, and if named, your spouse or domestic partner, for social use; commuting to one or more places of employment; and in connection with each of your businesses or professions.'
    },
    vehicleUseLabel: {
        id: 'qnb.spm.vehicleUse.vehicleUseLabel',
        defaultMessage: 'What is your car used for?'
    },
    vehicleUseHelpText: {
        id: 'qnb.spm.vehicleUse.vehicleUseHelpText',
        defaultMessage: 'Please select the buttons for more information.'
    },
    vehicleUseMobileSecondaryLabel: {
        id: 'qnb.spm.vehicleUse.vehicleUseMobileSecondaryLabel',
        defaultMessage: ' Please select an option for more information.'
    },
    vehicleUseEmploymentValidation: {
        id: 'qnb.spm.vehicleUse.vehicleUseEmploymentValidation',
        defaultMessage: 'You have told us that you, and if included, your spouse or domestic partner are not working, but you have selected {vehicleUse} use. Please correct your details.'
    },
    motorhomeUse: {
        id: 'qnb.spm.vehicleUse.motorhomeUse',
        defaultMessage: 'Our policy will cover you for Social, Domestic & Pleasure use.'
    },
    motorhomeUseHelpText: {
        id: 'qnb.spm.vehicleUse.motorhomeUseHelpText',
        defaultMessage: 'This will cover day-to-day use by yourself or any named drivers. This does not include any commuting to or from any place of employment, or any business use.'
    }
});
